const state = {
    message: '',
    isOpen: false,
}

const getters = {

}

const actions = {
    // set a message and open the notification at the same time
    notify({ commit }, message) {
        commit('SET_MESSAGE', message)
        commit('SET_IS_OPEN', true)
    },

    setMessage({ commit }, message) {
        commit('SET_MESSAGE', message)
    },

    setIsOpen({ commit }, isOpen) {
        commit('SET_IS_OPEN', isOpen)
    },
}

const mutations = {
    SET_MESSAGE(state, message) {
        state.message = message
    },

    SET_IS_OPEN(state, isOpen) {
        state.isOpen = isOpen
        if (isOpen) setTimeout(() => state.isOpen = false, 3000)            
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}